import React from 'react';
import GaodeMap from './map';

export default (props) => {
    return (
        <div>
            <GaodeMap />
        </div>
    );
};